import { Trans, useTranslation } from "react-i18next";
import Pack from "../Pack";
import ButtonBtn from "../buttons/ButtonBtn";
import styles from "../../css/reviews/HeroReviews.module.css";

import flameIcon from "../../img/list.svg";

const HeroReviews = ({ onCtaClick }) => {
  const { t } = useTranslation();
  const content = t("reviews.hero", { returnObjects: true });

  return (
    <Pack dataComponent={"hero-reviews"}>
      <div className={styles.hero}>
        <div className={styles.box}>
          <h1>{content.heading}</h1>
          <p className={styles.claim}>{content.claim}</p>
          <p className={styles.description}>
            <Trans i18nKey="reviews.hero.description" components={{ strong: <strong /> }} />
          </p>
          <ButtonBtn
            onClick={(e) => {
              e.target.blur?.();
              onCtaClick?.();
            }}
            style={{ marginInline: "0" }}
            justifyContent="flex-start"
          >
            {content.btn}
          </ButtonBtn>
          <span className={styles.note}>
            <img src={flameIcon} alt="" />
            {content.note}
          </span>
        </div>
        {/* PLACEHOLDER: nahradit reálným vizuálem/videem widgetu s recenzemi */}
        <div className={styles.mediaPlaceholder}>
          {content.mediaPlaceholder || "Náhled widgetu s recenzemi"}
        </div>
      </div>
    </Pack>
  );
};

export default HeroReviews;
